var $77ac944da51b7354$exports = {};
document.addEventListener("DOMContentLoaded", function() {
    setTimeout($77ac944da51b7354$var$iniciar, 2500);
});
document.addEventListener("scroll", $77ac944da51b7354$var$initOnEvent);
document.addEventListener("mousemove", $77ac944da51b7354$var$initOnEvent);
document.addEventListener("touchstart", $77ac944da51b7354$var$initOnEvent);
function $77ac944da51b7354$var$initOnEvent(event) {
    $77ac944da51b7354$var$iniciar();
    event.currentTarget.removeEventListener(event.type, $77ac944da51b7354$var$initOnEvent); // remove the event listener that got triggered
}
async function $77ac944da51b7354$var$initGtm(w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
        "gtm.start": new Date().getTime(),
        event: "gtm.js"
    });
    var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != "dataLayer" ? "&l=" + l : "";
    j.async = true;
    j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
    f.parentNode.insertBefore(j, f);
}
async function $77ac944da51b7354$var$iniciar() {
    if (window.DidInit) return false;
    window.dispatchEvent(new Event("resize"));
    window.DidInit = true;
    try {
        await $77ac944da51b7354$var$initGtm(window, document, "script", "dataLayer", "GTM-NPVS4R8J");
    } catch (error) {
        console.log("gtm", error);
    }
// try {
//   // await initPixel(
//   //   window,
//   //   document,
//   //   "script",
//   //   "https://connect.facebook.net/en_US/fbevents.js"
//   // );
//   console.log("--",window.location.href.search("/obrigado"));
//   if (window.location.href.search("/obrigado") > -1) {
//     console.log("LEAD");
//     fbq("track", "Lead");
//   } else {
//     console.log("VIEW");
//     fbq("track", "PageView");
//   }
// } catch (e) {
//   console.log("Erro ao iniciar o pixel", e);
// }
}


//# sourceMappingURL=index.567e796c.js.map
